import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { Wireframe } from '../models/Wireframe'
import { WireframeForm } from '../forms/WireframeForm'
import { WireframeFilter } from '../filters/WireframeFilter'
import { WireframeService } from '../services/WireframeService'

export const useWireframeStore: KsStoreHook<Wireframe, WireframeForm, WireframeFilter> = createKsStore({
  id: 'wireframes',
  modelClass: Wireframe,
  formClass: WireframeForm,
  filterClass: WireframeFilter,
  service: WireframeService,
  uniqueField: 'name',
  labelField: (item) => item.name || `Wireframe #${item.id}`,
  signalREventName: 'WireframeModel'
})
